(function($) {
    $.PolygonStyle = class {
        constructor(line_color, fill_color) {
            this.line_color = line_color;
            this.fill_color = fill_color;
        }
    };

    $.PolygonModule = class extends $.Component {
        constructor() {
            super();
            this._component_name = "polygon";

            this.polygons = [];
            this.styles = {
                default: new $.PolygonStyle("rgba(252,220,100,0.9)", "rgba(252,220,100,0.5)"),
                red:     new $.PolygonStyle("rgba(255,0  ,0  ,0.9)", "rgba(255,0  ,0  ,0.25)"),
                green:   new $.PolygonStyle("rgba(0  ,255,0  ,0.9)", "rgba(0  ,255,0  ,0.25)"),
                blue:    new $.PolygonStyle("rgba(0  ,0  ,255,0.9)", "rgba(0  ,0  ,255,0.25)"),
            };

            this._on_update_viewport = this._on_update_viewport.bind(this); 
        }

        _on_update_viewport (evt) { 
            const viewer = evt.eventSource;
            
            if (Array.isArray(viewer.abdo.polygons) && viewer.abdo.polygons.length > 0) {
                const pixelDensityRatio = OpenSeadragon.pixelDensityRatio;
                const ctx = viewer.drawer.canvas.getContext("2d"); 

                let prev_strokeStyle = ctx.strokeStyle;
                let prev_fillStyle = ctx.fillStyle;
                let prev_lineWidth = ctx.lineWidth;
                let prev_shadowColor = ctx.shadowColor;
                let prev_shadowBlur = ctx.shadowBlur; 

                for (const polygon of viewer.abdo.polygons) {
                    let style = this.styles.default; 
                    if (polygon.style in this.styles) {
                        style = this.styles[polygon.style];
                    } 
                    
                    ctx.strokeStyle = style.line_color;
                    ctx.fillStyle = style.fill_color;
                    ctx.lineWidth = 5;
                    ctx.shadowColor = "black";
                    ctx.shadowBlur = 15;
                    
                    ctx.beginPath();
                    for (let i = 1; i < polygon.coordinates.length; i++) {
                        const vertex = polygon.coordinates[i];
                        const prev_vertex = polygon.coordinates[i-1];

                        const vertex_px = viewer.viewport.pixelFromPoint(vertex);
                        if (i == 1) {
                            const prev_vertex_px = viewer.viewport.pixelFromPoint(prev_vertex);
                            ctx.moveTo(prev_vertex_px.x*pixelDensityRatio, prev_vertex_px.y*pixelDensityRatio);
                        }
                        ctx.lineTo(vertex_px.x*pixelDensityRatio, vertex_px.y*pixelDensityRatio);
                    } 

                    if (polygon.closed) {
                        ctx.closePath();
                        ctx.fill();
                    }

                    ctx.stroke(); 
                    
                }

                ctx.strokeStyle = prev_strokeStyle;
                ctx.fillStyle = prev_fillStyle;
                ctx.lineWidth = prev_lineWidth;
                ctx.shadowColor = prev_shadowColor;
                ctx.shadowBlur = prev_shadowBlur;
            }
        }

        /**
         * Initializes polygon component
         * 
         * example of parameters:
         * 
         * @example
            polygon: {
                styles: {
                    orange: new ABDOMap.PolygonStyle("rgba(255, 100, 0, 0.9)", "rgba(255, 100, 0, 0.25)")
                }
            },

         * @param {Object} options 
         */
        _init_ (options) {

            // add styles from config (if any)
            if (typeof(options.styles) !== "undefined") {
                for (const key in options.styles) {
                    if (Object.hasOwnProperty.call(options.styles, key)) {
                        this.styles[key] = options.styles[key];
                    }
                }
            }

            for (const viewer of this.parent.viewers) {
                viewer.abdo.polygons = [];
            }

            let url_params = new URLSearchParams(window.location.search);

            if (url_params.has("action")) {
                let actions = url_params.getAll("action");
                for (const action of actions) {
                    if (action === "draw_polygon") {
                        $.once("location_provider_ready", this._init_polygons.bind(this, url_params));
                    }
                }
            } 
        }

        _convert_vertex(polygon_vertex, viewer) {
            if (polygon_vertex.type == $.PolygonVertexType.latlon && viewer.abdo.localization) {
                let vp_coords = viewer.abdo.localization.lonlat2vp(polygon_vertex.y, polygon_vertex.x);
                if (Array.isArray(vp_coords) && vp_coords.length == 2) {
                    return new $.PolygonVertex(vp_coords[0], vp_coords[1], $.PolygonVertexType.viewport);
                }
            }

            return null;
        }

        _init_polygons(url_params) {
            // get a polygon from url parameters
            // todo: get multiple polygons from url params
            this.polygons.push($.Polygon.from_url_params(url_params));

            // add independent polygons for each viewer
            // to save processing power by precalculating viewport coordinates of polygon vertices
            for (const polygon of this.polygons) {
                if (polygon && Array.isArray(polygon.coordinates) && polygon.coordinates.length > 0) {
                    for (const viewer of this.parent.viewers) {
                        viewer.abdo.polygons = [];

                        // convert polygon vertices to vp coordinates
                        let vertices = [];
                        for (const vertex of polygon.coordinates) {
                            let converted_vertex = this._convert_vertex(vertex, viewer);
                            if (converted_vertex) {
                                vertices.push(converted_vertex);
                            }
                        }

                        // create new Polygon and add it to abdo.polygons
                        let new_polygon = new $.Polygon(vertices, polygon.closed, polygon.style);
                        viewer.abdo.polygons.push(new_polygon);

                        // add update-viewport handler
                        viewer.addHandler("update-viewport", this._on_update_viewport);
                    } 
                }
            }
           
        }



    }; 

    $.Component.create($.PolygonModule, {}, $.OSD); 

})(ABDOMap);
